import Loading from "components/common/Loading";
import CartDialog from "components/user/cart/Index";
import UserDetailPopUp from "components/user/UserDetailPopUp";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Login from "screens/auth/Login";
import Register from "screens/auth/Register";
import { fetchInitialData } from "store/slices/main.slice";
import MainPage from "./MainPage";
import MyOrder from "./MyOrder";
import ShopClosed from "./ShopClosed";
import { Modal, Box, Typography } from "@mui/material";
import Button from "components/common/Button";
type Props = {};

const UserContainer = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const loading = useAppSelector(({ main }) => main.loading);
  const { settings, companyData } = useAppSelector(({ main }) => main);

  const OnlineOrderingStatus = useAppSelector(
    ({ main }) => main.settings.OnlineOrderingStatus
  );
  const [showPopup, setShowPopup] = useState(false);
  const [orderTotal, setOrderTotal] = useState(0);
  const handleClosePopup = () => setShowPopup(false);

  useEffect(() => {
    dispatch(fetchInitialData(navigate));
  }, []);

  if (loading) return <Loading />;

  if (OnlineOrderingStatus) return <ShopClosed />;
  return (
    <>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/myOrders" element={<MyOrder />} />
      </Routes>
      <CartDialog setShowPopup={setShowPopup} setOrderTotal={setOrderTotal} />
      <UserDetailPopUp />
      <Modal open={showPopup} onClose={handleClosePopup}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: 280, sm: 400, md: 500 }, // Responsive width
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: { xs: 2, sm: 3, md: 4 }, // Responsive padding
            textAlign: "center",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontSize: { xs: "1.2rem", md: "1.5rem" }, // Responsive font size
              color: "primary.main", // Accent color for title
              fontWeight: "bold",
            }}
          >
           {settings.ShowCompanyName && companyData?.companyName
            ? companyData?.companyName
            : "RANGER POS"}
          </Typography>

          <Typography
            variant="body1"
            gutterBottom
            sx={{
              fontSize: { xs: "1rem", md: "1.2rem" },
              mb: 1,
              color: "black",
            }}
          >
            Your Total is: <strong>${orderTotal}</strong>
          </Typography>

          <Typography
            variant="body2"
            sx={{ fontSize: { xs: "0.9rem", md: "1rem" }, color: "black" }}
          >
            Your Order is placed successfully.
            <br />
            Thank you, visit again...!
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              mt: 3,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button onClick={() => (window.location.href = "/myOrders")}>
              Order Status
            </Button>

            <Button onClick={() => (window.location.href = "/")}>
              Go To Home Page
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default UserContainer;
